export const name = "RIGHT";
export const summary = `Gets the specified rightmost portion from a \`STRING\` or \`BYTES\` value.`;
export const reference = `
## RIGHT

Gets the specified rightmost portion from a \`STRING\` or \`BYTES\` value.

\`\`\`
RIGHT(value, length)
\`\`\`

### Description

Returns a \`STRING\` or \`BYTES\` value that consists of the specified number of rightmost characters or bytes from \`value\`. The \`length\` is an\`INT64\` that specifies the length of the returned value. If \`value\` is \`BYTES\`, \`length\` is the number of rightmost bytes to return. If \`value\` is \`STRING\`, \`length\` is the number of rightmost characters to return.

If \`length\` is 0, an empty \`STRING\` or \`BYTES\` value will be returned. If \`length\` is negative, an error will be returned. If \`length\`exceeds the number of characters or bytes from \`value\`, the original \`value\`will be returned.


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT 'apple' AS example, RIGHT('apple', 3) AS right_example

/*---------+---------------*
 | example | right_example |
 +---------+---------------+
 | apple | ple |
 *---------+---------------*/
\`\`\`



\`\`\`
SELECT b'apple' AS example, RIGHT(b'apple', 3) AS right_example

-- Note that the result of RIGHT is of type BYTES, displayed as a base64-encoded string.
/*----------+---------------*
 | example | right_example |
 +----------+---------------+
 | YXBwbGU= | cGxl |
 *----------+---------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
